export enum EngagementTypeEnum {
    applause = 'APPLAUSE',
    conversation = 'CONVERSATION',
    amplification = 'AMPLIFICATION'
}
